<script lang="ts">
    import { navstore, sprache, generalInfo } from "../store"

    import Navigation from "./Navigation.svelte"
    import Suchfeld from "./Suchfeld.svelte"

    let selectopen = false
    let navopen = false
    let searchopen = false
</script>

<header>
    <div class="wrapper">
        <div class="row">
            <div class="logo">
                <a href="/{$sprache != 'de' ? $sprache : ''}"
                    ><img src="/assets/img/db-infrago-logo-plain.svg" alt="Logo DB InfraGO" /></a
                >
            </div>
            <div class="grow">
                <div class="title">{$generalInfo?.metaTitle || "Verkehrsprojekt Deutsche Einheit Nr. 8"}</div>
            </div>
            <nav class="service">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <ul>
                    <li id="suche" class:active="{searchopen}">
                        <div class="overlay"><Suchfeld /></div>

                        <div class="trigger" on:click="{() => (searchopen = !searchopen)}">
                            <img src="/assets/icons/ic-db_action_search_20.svg" alt="Suche" />
                        </div>
                    </li>
                    <li id="lang" class:active="{selectopen}">
                        <div class="trigger" on:click="{() => (selectopen = !selectopen)}">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <img src="assets/icons/flag_{$sprache}.svg" alt="{$sprache}" />{$sprache}
                            <span class="icon"><img src="/assets/icons/chevron-down.svg" alt="ausklappen" /></span>
                        </div>
                        <div class="overlay" on:click="{() => (selectopen = false)}">
                            <a href="/" class="option"
                                ><img src="assets/icons/flag_de.svg" alt="Deutsche Sprache" />DE</a
                            >
                            <!-- <a href="/en" class="option"
                                ><img src="assets/icons/flag_en.svg" alt="Englische Sprache" />EN</a
                            > -->
                        </div>
                    </li>
                    <li class="mobile-menu" on:click="{() => (navopen = !navopen)}">
                        <div class="burger">
                            <div class="burger-line"></div>
                            <div class="burger-line"></div>
                            <div class="burger-line"></div>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="row">
            <nav class="nav grow" class:active="{navopen}">
                {#if $navstore[0]}
                    <Navigation data="{$navstore[0]}" level="{1}" depth="{3}" bind:navopen="{navopen}" />
                {/if}
            </nav>
        </div>
    </div>
</header>
